<template>
	<router-view></router-view>
</template>

<script>
export default {
	props: ['lang', 'siteData', 'slug'],
	data() {
		return {
			pageTitle: document.title,
			description: this.getMetaTag('description'),
			meta: [
				{ vmid: 'description', name: 'description', content: this.description }
			],
			loaded: false,
			pageLoading: null,
			customTransitionInProgress: null,
			headerMenu: false,
			sustainabilityMenu: false,
			content: false,
			additional: false,
			footer: false,
			requestingContent: false
		}
	},
	computed: {
		pageSlug() {
			return this.$route.params.slug || 'home'
		},
		transitionName() {
			return (this.customTransitionInProgress) ? 'none' : 'fade'
		},
		leaveSpeed() {
			return (this.customTransitionInProgress) ? 1200 : 500
		}
	},
    metaInfo() {
		return {
			title: this.pageTitle,
			meta: this.meta
		}
	},
	mounted() {
		if (typeof window.siteConfig !== 'undefined') {
			this.pageTitle = document.title || window.siteConfig.post.meta[0].content
			this.description = window.siteConfig.post.meta[1].content
		}
	},
	methods: {
		getMetaTag(name) {
			var metas = document.getElementsByTagName('meta');
			for (var x=0,y=metas.length; x<y; x++) {
				if (metas[x].name.toLowerCase() == name) {
					return metas[x].content;
				}
			}
			return ''
		},
		updateMenus(data) {
			this.headerMenu = data.headerMenu;
		},
		loadAdditionalData(data) {
		},
		clearAdditionalData() {
		},
		updateBodyClasses(slug) {
			var app = document.getElementById('app')
			if (slug==='home'||slug==='intro'||slug==='forside') {
				app.classList.add('wavy-page-wrapper')
			} else {
				app.classList.remove('wavy-page-wrapper')
			}
		},
		updateContent(data) {
			this.requestingContent = false
			if (typeof data.post !== 'undefined') {
				if (typeof data.post.title !== 'undefined') {
					this.pageTitle = data.post.title
				}
				if (typeof data.post.meta !== 'undefined') {
					this.meta = data.post.meta
				}
				this.headerStyle = data.post.header_style;
				this.components = {}
				this.content = false
				setTimeout((post) => {
					this.components = post.components || false
					this.content = post.content || false
				}, 50, data.post);
				this.loadAdditionalData(data)
				this.loading = false;
				this.pageLoading = false;
			} else {
				this.pageTitle = '';
				this.meta = {}
				this.components = {}
				this.content = false
				this.clearAdditionalData()
			}
		},
		getData() {
			if (typeof this.postType === 'undefined' || this.requestingContent) return
			this.requestingContent = true
			if (!this.customTransitionInProgress) {
				if (this.pageLoading===null) {
					this.loading = true;
				} else {
					this.pageLoading = true;
				}
			}
			var slug = (typeof this.slug !== 'undefined') ? this.slug : this.$route.params.slug;
			this.updateBodyClasses(slug);
			if (typeof window.dcSite.post!=='undefined') {
				this.updateContent(window.dcSite)
				delete window.dcSite.post
			} else {
				this.$http.get(window.dcSite.apiRoute + 'get/' + this.postType + '/' + slug + '?lang=' + this.lang).then(response => {
					setTimeout((response) => { 
						if (response.data.success) {
							this.updateContent(response.data)
						}
					}, 750, response);
				})
			}
		},
		updateGlobalSiteData(data) {
			this.$store.dispatch('updateGlobalData', data)
			if (data.headerMenu) {
				this.headerMenu = data.headerMenu;
			}
			if (data.footer) {
				this.footer = data.footer;
			}
		},
		getGlobalSiteData() {
			//console.log('get next page')
			if (this.loaded===true) return
			this.loaded = true
			if (typeof window.dcSite.siteConfig !== 'undefined') {
				this.updateGlobalSiteData(window.dcSite.siteConfig)
				delete window.dcSite.siteConfig
			} else {
				this.$http.get(window.dcSite.apiRoute + 'get/site-config?lang=' + this.lang).then(response => {
					if (response.data.success) {
						this.updateGlobalSiteData(response.data.data)
					} else {
						//console.log('failed')
					}
				});
			}
		},
		updateLoading(newVal) {
			//console.log('update loading: ' + newVal)
			this.loading = (newVal===false);
			if (!this.customTransitionInProgress) {
				this.pageLoading = (newVal===false);
			} 
		}
	},
	created() {
		this.getGlobalSiteData()
	},
	beforeRouteEnter(to, from, next) {
		setTimeout(() => { 
			document.body.classList.remove('overlay-open');
			document.body.classList.remove('menu-open');
		}, 50);
		setTimeout(() => { 
			document.body.classList.remove('home-intro-transition');
			document.body.classList.remove('no-scroll-top');
		}, 650);
		setTimeout(() => { 
			document.body.classList.remove('hide-footer');
		}, 950);
		next();
	},
	watch: {
		'$route': 'getData',
		content (newVal) {
			if (newVal) this.updateLoading(newVal);
		},
		components (newVal) {
			if (newVal) this.updateLoading(newVal);
		}
	}
}
</script>